import { atom } from "recoil";

const resourceState = atom<any>({
    key: "resourceState",
    default: {},
});

export default resourceState;
